import { render } from "./sql-chapter-4.vue?vue&type=template&id=cea427a6"
import script from "./sql-chapter-4.vue?vue&type=script&lang=js"
export * from "./sql-chapter-4.vue?vue&type=script&lang=js"

import "./sql-chapter-4.vue?vue&type=style&index=0&id=cea427a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__